// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Nbnmg","type":"styles_type__1BSWu","choices":"styles_choices__3DLv5"};